/* eslint
    new-cap: ["warn", { "capIsNew": false }],
    consistent-return: "warn",
    no-return-assign: "warn",
    @typescript-eslint/no-shadow: "warn",
    no-restricted-syntax: ["warn", "ForOfStatement"],
    guard-for-in: "warn"
*/

import { element as getElement, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { AddToCartState } from '@shared/easyfy.enums';
import EasyfyToaster, { MessageSeverity } from '@shared/easyfy.toaster';
import { hide, show, parseToBoolean } from '@shared/easyfy.utils';
import DialogModule from '@webModules/dialog.module';
import DisclaimerModule from '@webModules/disclaimer.module';
import basketService from '@webServices/basket.service';
import { initSlideProductList } from '@webModules/splideHelper';
import prescriptionService from '../services/prescription.service';
import productRecommendationsService from '../services/meds.productrecommendations.service';

namespace Easyfy.Modules {
    @invoke
    export class Basket {
        private toaster: EasyfyToaster;

        constructor() {
            new EasyfyToaster(null);
        }

        onInit() {
            globalEvent({
                type: 'click',
                event: {
                    action: 'add-to-cart',
                    callback: Basket.onAddToCart
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'add-to-cart-with-disclaimer',
                    callback: Basket.onAddToCartWithDisclaimer
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'basket-prescription-login',
                    callback: Basket.onPrescriptionLogin
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'basketrow-change',
                    callback: Basket.onBasketRowChange
                }
            });

            globalEvent({
                type: 'change',
                event: {
                    action: 'basketrow-set',
                    callback: Basket.onBasketRowSet
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'basketrow-remove',
                    callback: Basket.onBasketRowRemove
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'decrease-quantity',
                    callback: Basket.onDecreaseQuantity
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'increase-quantity',
                    callback: Basket.onIncreaseQuantity
                }
            });

            globalEvent({
                type: 'click',
                event: {
                    action: 'payment-provider-banner-click',
                    callback: Basket.showPaymentProviderBannerMessage
                }
            });

        }

        static onAddToCart = async (e) => {
            e.preventDefault();
            e.stopPropagation();

            Basket.AddToCart(e);

            return false;
        };

        static onAddToCartWithDisclaimer = async (e: Event) => {
            e.preventDefault();
            e.stopPropagation();

            DisclaimerModule.NeedDisclaimer(e).then((response) => {
                if (!response) {
                    Basket.AddToCart(e);
                    return false;
                }
                DisclaimerModule.ShowDisclaimer(e, () => {
                    Basket.AddToCart(e);
                });
            });
            return false;
        };

        static onPrescriptionLogin = async (e: Event) => {
            e.preventDefault();
            e.stopPropagation();

            const element: HTMLElement = e.target as HTMLElement;
            const dataTarget = element.getAttribute('data-target');
            if (dataTarget && dataTarget.trim() !== '') {
                location.href = dataTarget;
            }

            return false;
        };

        static onBasketRowChange = async (e) => {
            e.preventDefault();
            e.stopPropagation();
            let element: HTMLElement = e.target as HTMLElement;
            if (!element.attributes['data-rowid']) {
                element = e.target.parentElement;
            }

            const rowId = element.attributes['data-rowid']?.value;
            const quantity = element.attributes['data-add'] ? 1 : -1;

            await basketService
                .UpdateBasket(
                    {
                        rows: [
                            {
                                rowId,
                                changeQty: quantity,
                                trackingData: {
                                    actionOrigin: element.attributes['data-action-origin']?.value,
                                    searchProductOrigin: element.attributes['data-searchproduct-id']?.value,
                                    sponsorshipId: element.attributes['data-sponsorship-id']?.value
                                }
                            }
                        ]
                    },
                    element.attributes['data-token']?.value
                )
                .then((response) => {
                    Basket.renderBasket(response);
                    if (response.data.message) {
                        let messageSeverity: MessageSeverity = MessageSeverity.error;

                        if (response.data.success === true) {
                            messageSeverity = MessageSeverity.success;
                        }
                        EasyfyToaster.toaster(
                            messageSeverity,
                            response.data.message,
                            null,
                            null,
                            true
                        );
                    }
                })
                .catch(() => {
                    EasyfyToaster.toaster(
                        MessageSeverity.error,
                        'Error',
                        null,
                        null,
                        true
                    );
                });

            return false;
        };

        static onBasketRowSet = async (e) => {
            e.preventDefault();
            e.stopPropagation();

            const element: HTMLInputElement = e.target as HTMLInputElement;
            const rowId = element.attributes['data-rowid']?.value;
            const quantity: number = parseInt(element.value, 10);

            await basketService
                .UpdateBasket(
                    {
                        rows: [
                            {
                                rowId,
                                setQty: quantity,
                                trackingData: {
                                    actionOrigin: element.attributes['data-action-origin']?.value,
                                    searchProductOrigin: element.attributes['data-searchproduct-id']?.value,
                                    sponsorshipId: element.attributes['data-sponsorship-id']?.value
                                }
                            }
                        ]
                    },
                    element.attributes['data-token']?.value
                )
                .then((response) => {
                    Basket.renderBasket(response);
                    if (response.data.message) {
                        let messageSeverity: MessageSeverity = MessageSeverity.error;

                        if (response.data.success === true) {
                            messageSeverity = MessageSeverity.success;
                        }
                        EasyfyToaster.toaster(
                            messageSeverity,
                            response.data.message,
                            null,
                            null,
                            true
                        );
                    }
                })
                .catch(() => {
                    EasyfyToaster.toaster(
                        MessageSeverity.error,
                        'Error',
                        null,
                        null,
                        true
                    );
                });

            return false;
        };

        static onBasketRowRemove = async (e) => {
            e.preventDefault();
            e.stopPropagation();

            const element: HTMLElement = e.target as HTMLElement;

            await basketService
                .UpdateBasket(
                    {
                        rows: [
                            {
                                rowId: element.attributes['data-rowid']?.value,
                                setQty: 0,
                                trackingData: {
                                    actionOrigin: element.attributes['data-action-origin']?.value,
                                    searchProductOrigin: element.attributes['data-searchproduct-id']?.value,
                                    sponsorshipId: element.attributes['data-sponsorship-id']?.value
                                }
                            }
                        ]
                    },
                    element.attributes['data-token']?.value
                )
                .then((response) => {
                    Basket.renderBasket(response);
                    if (response.data.message) {
                        let messageSeverity: MessageSeverity = MessageSeverity.error;

                        if (response.data.success === true) {
                            messageSeverity = MessageSeverity.success;
                        }
                        EasyfyToaster.toaster(
                            messageSeverity,
                            response.data.message,
                            null,
                            null,
                            true
                        );
                    }
                })
                .catch(() => {
                    EasyfyToaster.toaster(
                        MessageSeverity.error,
                        'Error',
                        null,
                        null,
                        true
                    );
                });

            return false;
        };

        static onDecreaseQuantity() {
            const quantityInput = document.getElementById(
                'quantity'
            ) as HTMLInputElement;

            if (quantityInput) {
                quantityInput.stepDown();
            }

            return false;
        }

        static onIncreaseQuantity() {
            const quantityInput = document.getElementById(
                'quantity'
            ) as HTMLInputElement;

            if (quantityInput) {
                quantityInput.stepUp();
            }

            return false;
        }

        static onShowPrescriptionCart = async (e) => {
            e.preventDefault();
            e.stopPropagation();
            const evtElement: HTMLElement = e.target as HTMLElement;
            const detailsElement: HTMLDetailsElement = evtElement.closest(
                'details'
            ) as HTMLDetailsElement;
            const summaryElement = detailsElement.querySelector('summary');
            const cartId = summaryElement.attributes['data-cartId']?.value;
            const token = summaryElement.attributes['data-token']?.value;
            const renderTarget = document.querySelector(
                `[data-container="prescription-cart-${cartId}"]`
            );

            if (detailsElement.open) {
                detailsElement.open = false;
                return false;
            }

            const command: prescriptionService.GetCartCommand = {
                cartId
            };

            // Close any other open details elements
            const openDetailsElements = Array.from(
                document.querySelectorAll(
                    "div[data-container='mini-basket'] .details[open]"
                )
            ) as HTMLDetailsElement[];
            openDetailsElements.map((elem) => (elem.open = false));

            detailsElement.open = true;
            renderTarget.innerHTML =
                '<div class="loader m-b-medium m-t-medium" role="status" aria-live="polite" aria-label="Laddar"></div>';

            await prescriptionService
                .GetCart(command, token)
                .then((response) => {
                    if (
                        response.status !== 200 ||
                        response.data == null ||
                        response.data.prescriptionCart == null
                    ) {
                        renderTarget.innerHTML = '';
                        return false;
                    }

                    renderTarget.innerHTML = response.data.prescriptionCart;
                })
                .catch((error) => {
                    console.log(error);
                });

            return false;
        };

        static getBasket = async () => {
            await basketService
                .GetBasket()
                .then((response) => {
                    Basket.renderBasket(response);
                })
                .catch((error) => {
                    console.log(error);
                });

            return false;
        };

        static renderBasket = (response: any) => {
            if (response.status === 200 && response.data != null) {
                const headerBasket: HTMLElement = getElement(
                    '[data-container="header-basket"]'
                ) as HTMLElement;
                const miniBasket: HTMLElement = getElement(
                    '[data-container="mini-basket"]'
                ) as HTMLElement;
                const priceElement: HTMLElement = headerBasket.querySelector(
                    '[data-container="basket-price"]'
                ) as HTMLElement;
                const quantityElement: HTMLElement = headerBasket.querySelector(
                    '[data-container="basket-quantity"]'
                ) as HTMLElement;
                const headerCheckout: HTMLElement = document.querySelector(
                    '[data-container="header-checkout"]'
                ) as HTMLElement;

                if (response.data.totalQuantity > 0) {
                    if (priceElement) {
                        priceElement.innerHTML = response.data.totalPrice;
                        // show(priceElement);
                    }

                    if (quantityElement) {
                        quantityElement.innerHTML = response.data.totalQuantity;
                        show(quantityElement, 'flex');
                    }

                    if (headerBasket) {
                        headerBasket.removeAttribute('disabled');
                    }

                    if (headerCheckout) {
                        headerCheckout.removeAttribute('disabled');
                    }
                } else {
                    if (quantityElement) {
                        hide(quantityElement);
                    }

                    if (priceElement) {
                        // hide(priceElement);
                        priceElement.innerHTML = priceElement.dataset.basketText;
                    }

                    if (headerBasket) {
                        headerBasket.setAttribute('disabled', 'disabled');
                    }

                    if (headerCheckout) {
                        headerCheckout.setAttribute('disabled', 'disabled');
                    }
                }

                if (miniBasket) {
                    miniBasket.innerHTML = response.data.partial;
                }

                Basket.attachOnShowPrescriptionCartListener();
            }

            return false;
        };

        static attachOnShowPrescriptionCartListener = () => {
            const prescriptionCartSummaries = document.querySelectorAll(
                '[data-action="prescriptioncart-show"]'
            );
            prescriptionCartSummaries.forEach((s) => {
                s.addEventListener('click', Basket.onShowPrescriptionCart);
            });
        };

        static AddToCart = async (e) => {
            e.preventDefault();
            e.stopPropagation();
            let element: HTMLElement = e.target as HTMLElement;

            if (e.target.tagName === 'SPAN') {
                element = e.target.parentNode as HTMLElement;
            }
            let quantity: number = 1;

            /* Change element state to 'processing'. */
            element.dataset.state = AddToCartState.Processing;
            element.setAttribute('disabled', 'disabled');
            if (element.querySelectorAll('.state').length === 0) {
                element
                    .appendChild(document.createElement('div'))
                    .classList.add('state');
            }

            if (element.dataset.quantityInput) {
                const quantityInput = document.querySelector(
                    element.dataset.quantityInput
                ) as HTMLInputElement;

                if (quantityInput) {
                    quantity = parseInt(quantityInput.value, 10);
                }
            }

            const productIdList: string[] = [];
            const searchProductIdList: string[] = [];
            const sponsorshipIdList: string[] = [];
            const rows: object[] = [];
            /* Check if it's just one product or 'buy together'-products */
            if (element.attributes['data-productid']) {
              const productId = element.attributes['data-productid'].value;
              const searchProductId = element.attributes['data-searchproduct-id']?.value;
              const sponsorshipId = element.attributes['data-sponsorship-id']?.value;

              rows.push({
                productId,
                searchProductId,
                changeQty: quantity,
                trackingData: {
                  actionOrigin: element.attributes['data-action-origin']?.value,
                  searchProductOrigin: searchProductId,
                  sponsorshipId
                },
                properties: {
                  ReferredListName: element.attributes['data-referred-list-name']?.value,
                  ReferredSponsorshipId: element.attributes['data-referred-sponsorship-id']?.value
                }
              });
              productIdList.push(productId);

            }
            else if (element.attributes['data-product-ids-list']) {
              type IdPair = {
                productId: string;
                searchProductId: string;
              };

              // format of the value in the attribute: productId:searchProductId,productId:searchProductId
              const productIdsList: IdPair[] = element.attributes['data-product-ids-list'].value
                .split(',')
                .map(p => p.trim())
                .flatMap(part => {
                  if (!part.includes(':')) return [];

                  const [productId, searchProductId] = part.split(':');

                  if (!productId || !searchProductId) return [];

                  return [{ productId, searchProductId }];
                });

              productIdsList.forEach((idPair, i) => {
                rows.push({
                  productId: idPair.productId,
                  searchProductId: idPair.searchProductId,
                  changeQty: quantity,
                  trackingData: {
                    actionOrigin: element.attributes['data-action-origin']?.value,
                    searchProductOrigin: searchProductIdList[i],
                    sponsorshipId: sponsorshipIdList[i]
                  },
                  properties: {
                    ReferredListName: element.attributes['data-referred-list-name']?.value,
                    ReferredSponsorshipId: element.attributes['data-referred-sponsorship-id']?.value
                  }
                });

                productIdList.push(idPair.productId);
              });
            }



            let successfullUpdate = false;

            await basketService
                .UpdateBasket({ rows }, element.attributes['data-token']?.value)
                .then((response) => {
                    Basket.renderBasket(response);
                    if (response.data.message) {
                        /* Default is error/fail. */
                        let messageSeverity: MessageSeverity = MessageSeverity.error;
                        let elementState = AddToCartState.Fail;

                        if (response.data.success === true) {
                            messageSeverity = MessageSeverity.success;
                            elementState = AddToCartState.Success;
                            successfullUpdate = true;
                        }
                        EasyfyToaster.toaster(messageSeverity, response.data.message);
                        element.dataset.state = elementState;

                    }
                })
                .catch(() => {
                    EasyfyToaster.toaster(MessageSeverity.error, 'Error');

                    /* Change element state to 'Fail'. */
                    element.dataset.state = AddToCartState.Fail;
                });
            element.removeAttribute('disabled');

            const isProductPage = element.getAttribute('data-product-page') === 'true';
            if (successfullUpdate && isProductPage) {
                await Basket.showAddToBasketRecommendations(productIdList);
            }

            /* Remove element state. */
            setTimeout(() => {
                element.removeAttribute('data-state');
                element.querySelector('.state').remove();
            }, 3000);

            return false;
        };

        static showAddToBasketRecommendations = async (productIdList: string[]) => {

            const productPageAddToBasketContainer = document.getElementById(
                'addToBasketRecommendations'
            );

            if (productPageAddToBasketContainer.classList.contains('smooth-dropdown')) {
                // Only trigger the recommendations once per product page
                return;
            }

            const requestData: productRecommendationsService.ProductRecommendationRequest = {
                productIds: productIdList,
                searchProductId: '',
                personalize: true,
                seoCategoryName: '',
                brandId: '',
                isExclusiveToBrand: parseToBoolean(
                    productPageAddToBasketContainer.getAttribute(
                        'data-recommendations-exclusive'
                    )
                ),
                recommendationType: 'AddToBasket',
                productPageHasVideo: false,
                noCache: true
            };

            await productRecommendationsService
                .GetProductRecommendations(requestData)
                .then((response) => {
                    if (response.status === 200 && response.data?.partial) {

                        if (productPageAddToBasketContainer) {

                            productPageAddToBasketContainer.classList.add('smooth-dropdown');

                            setTimeout(() => {
                                productPageAddToBasketContainer.innerHTML = response.data.partial;

                                const productListComponent =
                                    productPageAddToBasketContainer.querySelector(
                                        '[data-container="productlist-scroll"]'
                                    );
                                initSlideProductList(productListComponent);
                                productPageAddToBasketContainer.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'end'
                                });
                                productPageAddToBasketContainer.classList.add('open');
                            }, 300);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        static showPaymentProviderBannerMessage = async () => {
            const paymentProviderBannerMessage = document.querySelector('#payment-provider-banner-message') as HTMLDialogElement;
            if (paymentProviderBannerMessage) {
                await DialogModule.ShowDialog(paymentProviderBannerMessage);
            }
      };

      static SyncBasketFromCart = async () => {
        await basketService
          .SyncBasketFromCart()
          .then((response) => {
            if (response.data != null && response.data.success == true) {
              Basket.renderBasket(response);
            }
          })
          .catch((error) => {
            console.log(error);
          });

        return false;
      }
    }
}

export default Easyfy.Modules;
